<!-- Curve Plotter -->
<!-- Loader -->
<ng-container *ngIf="loading">
  Loading......
  <div class="loading">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </div>
</ng-container>
<!-- end of loader -->
<ng-container *ngIf="!loading">
  <ng-container *ngIf="role">
  <div class="mychart" id='mychart'>
    <google-chart #chart (ready)="chartReady(chart)" id="chart" (error)="onError($event)"
      [title]="title"
      [type]="type"
      [data]="data"
      [columns]="columnNames"
      [options]="options"
      [width]="width"
      [height]="height"
      >
    </google-chart>
    <!-- download curve -->
    <a class="right" href="#" (click)="downloadCanvas($event)" id="btn"> DOWNLOAD GRAPH</a>
  </div>
  </ng-container>
</ng-container>
<!-- end of curve plotter -->
